<template>
    <div class="card">
        <div class="card-header">
            Nastavení druhů návštěv
        </div>
        <div class="card-body">
            <div class="row between_rows justify-content-center">
                <table v-if="visit_purposes.length > 0 && !waitForResponse" class="table" data-testid="settings-visit-purpose-list">
                    <thead>
                    <tr>
                        <th>Důvod návštěvy</th>
                        <th>Délka návštěvy</th>
                        <th>Výchozí</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(visit_purpose, index) in visit_purposes" :key="visit_purpose.id" :data-testid="'settings-visit-purpose-row-' + visit_purpose.id">
                        <td v-if="edited_visit_purpose.id !=  visit_purpose.id" :data-testid="'settings-visit-purpose-name-' + visit_purpose.id">{{ visit_purpose.purpose }}</td>
                        <td v-else>
                            <input v-model="edited_visit_purpose.purpose" type="text" class="form-control mr-sm-2" aria-describedby="purposeHelp" id="editPurpose" :data-testid="'settings-visit-purpose-edit-name-' + visit_purpose.id">
                        </td>
                        <td v-if="edited_visit_purpose.id !=  visit_purpose.id">{{ visit_purpose.duration * minutes_per_window }} minut</td>
                        <td v-else>
                            <select v-model="edited_visit_purpose.duration" class="form-control mr-sm-2" id="editDuration" :data-testid="'settings-visit-purpose-edit-duration-' + visit_purpose.id">
                                <option value="" disabled selected>zvolit čas</option>
                                <option v-for="duration in 24" v-bind:value="duration">{{ duration*5 }} minut</option>
                            </select>
                        </td>
                        <td v-if="visit_purpose.default == true" :data-defualt="id_default = visit_purpose.id" :data-testid="'settings-visit-purpose-default-' + visit_purpose.id"><i class="fa fa-check-circle"></i></td>
                        <td v-on:mouseover="id_hovered = visit_purpose.id" v-on:mouseleave="id_hovered = ''" v-on:click="changeDefaultTo(visit_purpose.id)" v-else :data-testid="'settings-visit-purpose-make-default-' + visit_purpose.id">
                            <i v-if="id_hovered == visit_purpose.id" class="fa fa-check-circle-o"></i>
                            <i class="fa fa-circle-o" v-else></i>
                        </td>
                        <td v-if="edited_visit_purpose.id !=  visit_purpose.id">
                            <button class="btn btn-primary btn-sm" v-on:click="edited_visit_purpose = Object.assign({}, visit_purpose)" :data-testid="'settings-visit-purpose-edit-' + visit_purpose.id">Upravit</button>
                        </td>
                        <td v-else>
                            <button class="btn btn-success btn-sm" v-on:click="putVisitPurpose()" :data-testid="'settings-visit-purpose-save-' + visit_purpose.id">Uložit</button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div v-if="waitForResponse" class="">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                </div>
            </div>
        </div>
        <div class="card-block bg-light">
            <form class="form-inline" @submit.prevent="postVisitPurpose">
                <label for="purpose" class="mr-sm-2">Důvod návštěvy</label>
                <input v-model="visit_purpose.purpose" type="text" class="form-control mr-sm-2" aria-describedby="purposeHelp" id="purpose" data-testid="settings-visit-purpose-new-name">
                <small id="purposeHelp" class="form-text text-muted"></small>

                <label for="duration" class="mr-sm-2">Délka návštěvy:</label>
                <select v-model="visit_purpose.duration" class="form-control mr-sm-2" id="duration" data-testid="settings-visit-purpose-new-duration">
                    <option value="" disabled selected>zvolit čas</option>
                    <option v-for="duration in 24" v-bind:value="duration">{{ duration*5 }} minut</option>
                </select>
                <button v-if="!waitForSave" type="submit" class="btn btn-primary" data-testid="settings-visit-purpose-add">Přidat druh návštěvy</button>
                <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
            </form>
        </div>
    </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  export default {
    data () {
      return {
        setting: require('../../../variables.js'),
        visit_purposes: '',
        edited_visit_purpose: {
          id: '',
          purpose: '',
          duration: '',
          default: ''
        },
        minutes_per_window: 5, // TODO - nastavit minuty ze systémového nastavení (velikost okénka)
        waitForResponse: false,
        waitForSave: false,
        id_default: '',
        id_hovered: '',
        visit_purpose: {
          purpose: '',
          duration: 30 / this.minutes_per_window // TODO - nastavit dobu podle systémového okénka na asi 20 nebo 30 minut
        }
      }
    },
    methods: {
      getVisitPurposes () {
        this.waitForResponse = true
        this.$http.get(this.setting.hostname + 'visit_purpose').then(response => {
          this.visit_purposes = response.data
          this.waitForResponse = false
        }, response => {
          this.waitForResponse = false
        })
      },
      changeDefaultTo (newId) {
        var visitPurposeOldDefault = {id: this.id_default, default: false}
        this.$http.put(this.setting.hostname + 'visit_purpose/' + this.id_default, visitPurposeOldDefault, {emulateJSON: true}).then(response => {
          this.submited = response.data
          var visitPurposeNewDefault = {id: newId, default: true}
          this.$http.put(this.setting.hostname + 'visit_purpose/' + newId, visitPurposeNewDefault, {emulateJSON: true}).then(response => {
            this.submited = response.data
            this.getVisitPurposes()
          }, response => {
            this.errors = response.data.errors
          })
        }, response => {
          this.errors = response.data.errors
        })
      },
      postVisitPurpose () {
        this.waitForSave = true
        this.$http.post(this.setting.hostname + 'visit_purpose', this.visit_purpose, {emulateJSON: true}).then(response => {
          this.waitForSave = false
          this.getVisitPurposes()
        }, response => {
          this.errors = response.data.errors
          this.waitForSave = false
        })
      },
      putVisitPurpose () {
        this.$http.put(this.setting.hostname + 'visit_purpose/' + this.edited_visit_purpose.id, this.edited_visit_purpose, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.getVisitPurposes()
          this.edited_visit_purpose = ''
        }, response => {
          this.errors = response.data.errors
        })
      }
    },
    beforeMount () {
      this.getVisitPurposes()
    }

  }
</script>



// WEBPACK FOOTER //
// src/views/Setting/components/VisitPurposes.vue?8dc1f372